exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ForgotPassword-linetext-8Nexi::after {\n\tcontent: '';\n\tposition: absolute;\n\ttop: 9px;\n\tright: -30px;\n\twidth: 26px;\n\theight: 1px;\n\tbackground-color: var(--menu-color);\n}\n.ForgotPassword-closeIcon-pQWw4{\n\theight: 30px;\n    margin-top: -5px;\n    margin-left: -8px;\n    background: var(--icon-bg-color);\n    border-radius: 20px;\n}", ""]);

// exports
exports.locals = {
	"linetext": "ForgotPassword-linetext-8Nexi",
	"closeIcon": "ForgotPassword-closeIcon-pQWw4"
};